const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;

/** True inside Instagram / Facebook / TikTok / Snapchat in-app browsers. */
export const isInAppBrowser = /Instagram|FBAN|FBAV|FB_IAB|BytedanceWebview|musical_ly|TikTok|Snapchat/i.test(ua);
export const isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isDebug = new URLSearchParams(location.search).has('debug');

export function queryParam(name: string): string | undefined {
  return new URLSearchParams(location.search).get(name) ?? undefined;
}
